const GraphQLForm = require('app/graphql/Form');
const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitSupplierSectors',
            'supplier': null,
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.supplier = this.settings.supplier;
        if(!this.supplier){
            window.notify("Missing supplier parameter to SectorForm","error");
        }

        this.$form = $('<form/>')
        .addClass('supplier-sector-form');

        this.loadData();

        super.initialize();
    }

    getSupplier(){
        return this.supplier;
    }

    getForm(){
        return this.$form;
    }

    refresh(){
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$form.html('');

        let queries = [
            this.buildSupplierQuery(),
            this.buildDepartementQuery()
        ];


        if(queries.length <= 0){
            return this.fillForm({});
        }

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildDepartementQuery(){
        var self = this;

        let id = this.supplier.id;
        let parameters = {
            'first': 10000,
            'orderBy': 'name',
            'dir': 'ASC'
        };

        let fields = [
            'id',
            'name',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'departments',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;

    }

    buildSupplierQuery(){
        var self = this;

        let id = this.supplier.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',
            'sectors { id name emails departments { id } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplier',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    fillForm(data){
        this.supplier = data.supplier;
        this.departments = data.departments.edges;

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .hide();

        this.$btnSubmit
        .append(window.translate('app.supplier.show.tabs.info.sectorForm.submit.label'));

        this.$form
        .append(
            $('<div/>')
            .addClass('white-box')
            .append(this.buildForm())
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center mt-4')
                .append(this.$btnSubmit)
            )
        );

        window.select2($('.sector-departement-select'));

        if($('.supplier-sector-container').length > 0){
            this.$btnSubmit.show();
        }

        return this.$form;
    }

    getFields(){
        let fields = super.getFields();
        fields.push('supplier { id }');
        return fields;
    }
    
    getVariables(){
        let variables = {};

        if(this.supplier.id){
            variables.supplier = {
                'value': this.supplier.id,
                'type': 'Int'
            }
        }

        return variables;
    }

    buildForm(){
        var self = this;

        let $box = $('<div/>');

        //LABEL
        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.supplier.show.tabs.info.sectorForm.label'))
        .appendTo($box);

        let $sectorsContainer = $('<div/>');

        let sectors = this.supplier.sectors;
        if(sectors.length > 0){
            for(var index in sectors){
                let sector = sectors[index];
                let $item = this.buildSectorContainer(sector,index);

                $sectorsContainer.append($item);
            }
        }

        let $btnAddSector = $('<button/>')
        .addClass('btn btn-sm btn-info btn-sector-add')
        .append(
            $('<i/>')
            .addClass('fas fa-plus')
        )
        .on('click',function(event){
            event.stopPropagation();
            event.preventDefault();

            let sector = {
                'id': null,
                'name': '',
                'emails': '',
                'departments': []
            };

            let index = self.getNextFreeIndex();

            let $item = self.buildSectorContainer(sector,index);
            $sectorsContainer.append($item);
            window.select2($('.sector-departement-select',$item));
            self.$btnSubmit.show();
        });

        $box
        .append($sectorsContainer)
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center')
            .append($btnAddSector)
        )

        return $box;
    }

    getNextFreeIndex(){
        let end = false;
        let i = 0;
        let limit = this.departments.length;
        while(!end){
            if(i > limit){
                end = true;
            }
            if($('.supplier-sector-container[data-index="'+i+'"]').length <= 0){
                return i;
            }
            i++;
        }
        return limit;
    }

    buildSectorContainer(sector,index){
        var self = this;

        let number = parseInt(index)+1;
        let prefix = 'sectors['+index+']';
        let prefixId = 'sector'+index;

        let id = sector.id;
        let name = sector.name;
        let emails = sector.emails;

        let $box = $('<div/>')
        .attr('data-index',index)
        .addClass('supplier-sector-container bg-light p-4 mb-2');

        let $btnRemove = $('<button/>')
        .addClass('btn btn-text text-danger')
        .append(
            $('<i/>')
            .addClass('fas fa-times')
        )
        .on('click',function(){
            $box.remove();
        })

        $box.append(
            $('<div/>')
            .addClass('float-end')
            .append($btnRemove)
        );


        let $inputId = $('<input/>')
        .attr('type','hidden')
        .attr('name',prefix+'[id]')
        .val(id);
        $box.append($inputId);

        //FIELD label
        let $label = $('<h6/>')
        .addClass('box-title')
        .append(window.translate('app.supplier.show.tabs.info.sectorForm.sector.label',{'%number%':number}))
        .appendTo($box);


        //FIELD name
        let $nameLabel = $('<label/>')
        .attr('for',prefixId+'name')
        .append(window.translate('app.supplier.show.tabs.info.sectorForm.name.label'));
        let $nameInput = $('<input/>')
        .attr('id',prefixId+'name')
        .attr('type','text')
        .attr('name',prefix+'[name]')
        .addClass('form-control')
        .val(name);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($nameLabel)
            .append($nameInput)
        )

        //FIELD emails
        let $emailsLabel = $('<label/>')
        .attr('for',prefixId+'emails')
        .append(window.translate('app.supplier.show.tabs.info.sectorForm.emails.label'));
        let $emailsInput = $('<input/>')
        .attr('type','text')
        .attr('id',prefixId+'emails')
        .attr('name',prefix+'[emails]')
        .addClass('form-control')
        .val(emails);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($emailsLabel)
            .append($emailsInput)
        )

        //FIELD departments
        let $departmentsLabel = $('<label/>')
        .attr('for',prefixId+'departments')
        .append(window.translate('app.supplier.show.tabs.info.sectorForm.departments.label'));
        let $departmentsSelect = $('<select/>')
        .attr('id',prefixId+'departments')
        .attr('name',prefix+'[departments][]')
        .attr('multiple','multiple')
        .addClass('form-control sector-departement-select');

        for(var i in this.departments){
            let department = this.departments[i].node;

            let $option = $('<option/>')
            .val(department.id)
            .append(department.name);
            if(this.hasDepartement(sector,department.id)){
                $option.attr('selected','selected');
            }

            $departmentsSelect.append($option);

        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($departmentsLabel)
            .append($departmentsSelect)
        )

        return $box;
    }

    hasDepartement(sector,departementId){
        for(var i in sector.departments){
            let department = sector.departments[i];
            if(department.id == departementId){
                return true;
            }
        }
        return false;
    }

}

module.exports = Form;

